import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import styled from 'styled-components';
import { colors, fontSizes, opacities, spacing } from '../../../defaultTheme';
import useAutoFocus from '../../customHooks/useAutoFocus';
import Small from '../../typography/Small';
export const COMPONENT_HEIGHT = 48;
export const CONTAINER_HEIGHT = 275;
export const FieldWrapper = styled.div `
  width: 100%;
`;
export const NativeSelectContainer = styled.select `
  display: none;
`;
export const SelectOuterWrapper = styled.div `
  position: relative;
  box-sizing: border-box;
  font-family: inherit;
`;
export const SelectInnerWrapper = styled.div `
  font-size: inherit;
  color: ${({ error }) => (error ? colors.error : colors.mediumGrey)};
  width: 100%;
  height: ${COMPONENT_HEIGHT}px;
  position: relative;
  border-radius: 6px;
  box-shadow: 0 0 0
    ${({ error }) => error ? `2px ${colors.error};` : `1px ${colors.heavyGrey};`};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &:hover {
    ${({ error, isDisabled }) => error || isDisabled ? '' : `box-shadow: 0 0 0 2px ${colors.heavyGrey};`}
    cursor: normal;
  }
  background-color: ${({ isDisabled }) => isDisabled ? colors.lightestGrey : colors.white};

  &:focus-within {
    ${({ error, isDisabled, theme }) => !isDisabled &&
    `
       box-shadow: 0 0 0 ${error ? '3px' : '2px'} ${error ? colors.error : theme.field.focus};
        color: ${colors.heavyGrey};
      `}
  }

  transition: all 100ms ease 0s;
  outline: 0px !important;
  justify-content: space-between;
  cursor: default;
`;
export const Label = styled.label `
  font-size: ${fontSizes.small}px;
  left: ${({ hasIcon }) => (hasIcon ? '48px' : '16px')};
  opacity: 0;
  left: 0;
  top: 3px;
  transition-property: opacity;
  transition-duration: 0.2s;
  position: absolute;
  color: ${({ error, isDisabled, theme }) => {
    if (error)
        return colors.error;
    if (!isDisabled)
        return theme.field.label;
    return colors.mediumGrey;
}};

  ${({ animateLabel, isMenuOpen, hasSelection }) => (animateLabel && isMenuOpen) || hasSelection ? 'opacity: 1;' : ''}
`;
export const SelectedPlaceholder = styled.span `
  position: absolute;
  left: 0;
  bottom: 13px;
  transition-property: bottom;
  transition-duration: 0.2s;
  display: ${({ isMenuOpen, isNotDefaultSelection }) => {
    if (isNotDefaultSelection)
        return 'block';
    if (isMenuOpen)
        return 'none';
    return 'block';
}};
  color: ${({ hasSelection, error, isNotDefaultSelection }) => {
    if (error && !isNotDefaultSelection)
        return colors.error;
    return hasSelection ? colors.black : colors.mediumGrey;
}};
  ${({ animateLabel, isMenuOpen, hasSelection }) => (animateLabel && isMenuOpen) || hasSelection ? 'bottom: 5px;' : ''}
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SelectValueWrapper = styled.div `
  font-size: inherit;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: ${colors.mediumGrey};
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  flex: 1 1 0%;
  padding: 0px 16px;
  padding-left: ${({ hasIcon }) => (hasIcon ? '0' : '16px')};
  overflow: hidden;
`;
export const Placeholder = styled.div `
  font-family: 'Open Sans';
  font-size: inherit;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: ${colors.mediumGrey};
  margin-right: 2px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  user-select: none;
`;
export const SelectInputWrapper = styled.div `
  padding-bottom: 2px;
  padding-top: 2px;
  visibility: visible;
  color: ${colors.black};
  box-sizing: border-box;
  margin: 2px;
`;
export const SelectInput = styled.div `
  box-sizing: content-box;
  width: 2px;
  background: 0px center;
  border: 0px;
  font-size: inherit;
  opacity: 1;
  outline: 0px;
  padding: 0px;
  color: inherit;
`;
export const RightIconWrapper = styled.div `
  font-size: 20px;
  display: flex;
  box-sizing: border-box;
  padding: 0 16px;
  transition: color 150ms ease 0s;
  color: ${colors.mediumGrey};
`;
export const OptionsMenuWrapper = styled.div `
  background-color: ${colors.white};
  box-shadow: ${({ error }) => error
    ? `0 0 0 2px ${colors.error};`
    : `0 1px 10px 0 ${opacities.rgbaLight10}, 0 ${spacing.xsmall}px 5px 0 ${opacities.rgbaLight08}, 0 2px ${spacing.xsmall}px 0 ${opacities.rgbaLight04}`};
  border: 1px solid ${colors.heavyGrey};
  border-radius: ${spacing.xsmall}px;
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  width: calc(100% + 2px);
  margin: ${({ placement }) => placement === 'TOP'
    ? `0 0 ${spacing.xsmall}px -1px`
    : `${spacing.xsmall}px 0 0 -1px`};
  ${({ placement }) => (placement === 'TOP' ? 'bottom: 49px;' : '')}
`;
export const OptionsMenuInnerWrapper = styled.ul `
  overflow-y: auto;
  position: relative;
  padding: unset;
  margin: unset;
  box-sizing: border-box;
  max-height: ${CONTAINER_HEIGHT}px;
`;
export const OptionWrapper = styled.li `
  display: flex;
  align-items: center;
  padding-left: ${({ hasIcon, disabled }) => hasIcon || disabled ? '0' : '16px'};
  padding-right: 16px;
  background-color: ${({ selected, theme }) => selected ? theme.hoverBackground : 'transparent'};
  outline: ${({ focused }) => (focused ? `auto ${colors.cyanBlue}` : 'none')};
  border-bottom: ${({ focused }) => focused ? `none` : `solid 1px ${colors.heavyGrey}`};
  min-height: ${COMPONENT_HEIGHT}px;
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  &:hover {
    background-color: ${({ theme }) => theme.hoverBackground};
  }
  &:last-of-type {
    border-bottom: none;
  }
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  color: ${({ disabled }) => (disabled ? colors.heavyGrey : 'inherit')};
  justify-content: ${({ disabled }) => (disabled ? 'center' : 'unset')};
`;
export const Option = styled.div `
  color: inherit;
  padding: 12px 0px;
  cursor: default;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
`;
export const ErrorIconWrapper = styled.div `
  height: 100%;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const HelpText = styled(Small) `
  display: block;
  padding: 5px 0px;
  flex-basis: 100%;
  color: ${({ $isError }) => ($isError ? colors.error : colors.mediumGrey)};
`;
export const HelpTextWrapper = styled.div `
  display: flex;
  color: ${({ $isError }) => ($isError ? colors.error : colors.mediumGrey)};
  align-items: center;
`;
export const LeftIconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 44px;
  width: 44px;
  color: ${({ error, isMenuOpen, theme, isDisabled }) => {
    if (error && !isMenuOpen)
        return `${colors.error};`;
    if (!isDisabled)
        return `${theme.field.icon};`;
    return `${colors.mediumGrey};`;
}};
`;
export const SearchableInput = styled.input `
  background: inherit;
  border: none;
  color: inherit;
  font-size: inherit;
  outline: none;
  width: inherit;
  padding: 0;
`;
export const HelpAndError = ({ error, helpText, id, errorIcon }) => {
    const isError = !!error;
    if (isError) {
        return (_jsxs(_Fragment, { children: [_jsx(ErrorIconWrapper, { children: errorIcon }), _jsx(HelpText, Object.assign({ id: id, "$isError": true }, { children: error }))] }));
    }
    return _jsx(HelpText, Object.assign({ id: id }, { children: helpText }));
};
export const NativeSelect = ({ id, name, required, tabIndex, options, selectedOption, error, onChange, nativeSelectRef, ariaDescribedBy, dataCy }) => {
    return (_jsx(NativeSelectContainer, Object.assign({ id: `${id}-native`, ref: nativeSelectRef, "aria-describedby": ariaDescribedBy, "aria-invalid": !!error, value: selectedOption && selectedOption.value, name: name, onChange: () => onChange(selectedOption), required: required, tabIndex: tabIndex, "data-cy": dataCy && `${dataCy}.select` }, { children: options.map((option, index) => (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), `${index + 1}`))) })));
};
const RightIcon = ({ isDisabled, isMenuOpen, rightIconOpen, rightIconClosed, onClick }) => {
    if (isDisabled)
        return null;
    return (_jsx(RightIconWrapper, Object.assign({ "aria-hidden": "true", onClickCapture: onClick }, { children: isMenuOpen ? rightIconOpen : rightIconClosed })));
};
export const SearchableSelectValue = ({ term, onSearchChange, placeholder }) => {
    const ref = useRef();
    useAutoFocus(ref);
    return (_jsx(SearchableInput, { ref: ref, type: "text", value: term, onChange: (e) => onSearchChange(e.target.value), placeholder: placeholder }));
};
export const SelectValue = ({ leftIcon, hasSelection, isMenuOpen, isDisabled, isSearchable, error, dataCy, placeholder, selectedOptionLabel, animateLabel, id, name, rightIconOpen, rightIconClosed, isNotDefaultSelection, searchText, onSearchChange, onRightIconClick }) => {
    return (_jsxs(_Fragment, { children: [leftIcon && (_jsx(LeftIconWrapper, Object.assign({ error: error, isMenuOpen: isMenuOpen, isDisabled: isDisabled }, { children: leftIcon }))), _jsx(SelectValueWrapper, Object.assign({ hasIcon: !!leftIcon }, { children: isSearchable && isMenuOpen ? (_jsx(SearchableSelectValue, { term: searchText, onSearchChange: onSearchChange, placeholder: selectedOptionLabel || placeholder })) : (_jsxs(_Fragment, { children: [_jsxs(Placeholder, { children: [_jsx(Label, Object.assign({ hasSelection: hasSelection, animateLabel: animateLabel, isMenuOpen: isMenuOpen, htmlFor: `${id}-native`, error: error, isDisabled: isDisabled, id: `${id}-label`, "data-cy": dataCy && `${dataCy}.label` }, { children: placeholder })), _jsx(SelectedPlaceholder, Object.assign({ hasSelection: hasSelection, animateLabel: animateLabel, isMenuOpen: isMenuOpen, error: error, isNotDefaultSelection: isNotDefaultSelection, "data-cy": dataCy && `${dataCy}.selection` }, { children: selectedOptionLabel }))] }), _jsx(SelectInputWrapper, { children: _jsx(SelectInput, { id: id, name: name }) })] })) })), _jsx(RightIcon, { isDisabled: isDisabled, isMenuOpen: isMenuOpen, rightIconClosed: rightIconClosed, rightIconOpen: rightIconOpen, onClick: onRightIconClick })] }));
};
//# sourceMappingURL=subcomponents.js.map